var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12692",
    "data-name": "Group 12692",
    transform: "translate(2.986 -5.014)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31738",
    "data-name": "Rectangle 31738",
    width: 1.786,
    height: 10,
    rx: 0.893,
    transform: "translate(1.121 5.014)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31739",
    "data-name": "Rectangle 31739",
    width: 1.786,
    height: 10,
    rx: 0.893,
    transform: "translate(7.014 9.121) rotate(90)",
    fill: "#56aa1c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f6b4b0300977e166765650a8f497ea8a.svg";
export { ForwardRef as ReactComponent };